import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isAfter, isBefore, isValid, parse } from 'date-fns';
import { isCpfValid } from '../utils/isCpfValid';
import { onlyNumbers } from '../utils/onlyNumbers';

type ValidationFn = (control: AbstractControl) => ValidationErrors | null;

export class CustomValidators {
  static date(control: AbstractControl): ValidationErrors | null {
    const value = onlyNumbers(control.value ?? '');
    const date = parse(value, 'ddMMyyyy', new Date());

    if (!isValid(date)) {
      return { incorrectDate: true };
    }

    return null;
  }

  static dateAfterToday(format = 'ddMMyyyy'): ValidationFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = onlyNumbers(control.value ?? '');
      const date = parse(value, format, new Date());

      if (!isValid(date)) {
        return { incorrectDate: true };
      }

      if (isAfter(date, new Date())) {
        return { dateAfterToday: true };
      }

      return null;
    };
  }

  static dateBeforeToday(format = 'ddMMyyyy'): ValidationFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }

      const value = onlyNumbers(control.value);
      const date = parse(value, format, new Date());

      if (!isValid(date)) {
        return { incorrectDate: true };
      }

      if (isBefore(new Date(), date)) {
        return { dateBeforeToday: true };
      }

      return null;
    };
  }

  static cpf(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    if (isCpfValid(control.value)) {
      return null;
    }

    return {
      invalidCpf: true,
    };
  }

  static password = (control: AbstractControl): ValidationErrors | null => {
    const value = String(control.value);

    if (value.length < 8) {
      return { invalid: 'A senha não pode ter menos que 8 caracteres.' };
    }

    if (value.length > 20) {
      return { invalid: 'A senha não pode ter mais que 20 caracteres.' };
    }

    if (!value.match(/[A-Z]/g)) {
      return {
        invalid: 'A senha deve conter pelo menos 1 caractere maiúsculo.',
      };
    }

    if (!value.match(/[0-9]/g)) {
      return {
        invalid: 'A senha deve conter pelo menos 1 número.',
      };
    }

    if (!value.match(/[^a-z^A-Z^0-9]/g)) {
      return {
        invalid: 'A senha deve conter pelo menos 1 caractere especial.',
      };
    }

    return null;
  };
  static nomePortalCliente = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const value = control.value ?? '';

    if (value.trim().length === 0) {
      return { customValidation: 'Este campo é obrigatório' };
    }

    const hasNumbers = !!value.match(/\d/g);

    if (hasNumbers) {
      return { customValidation: 'Este campo não pode conter numéricos' };
    }

    if (value.includes(' ')) {
      return { customValidation: 'Este campo não conter espaços' };
    }

    if (value.startsWith('-')) {
      return { customValidation: 'Este campo não pode começar com hífen' };
    }

    if (value.endsWith('-')) {
      return { customValidation: 'Este campo não pode terminar com hífen' };
    }

    if (value.includes('--')) {
      return {
        customValidation: 'Este campo não pode conter dois hífens seguidos',
      };
    }

    if (value.length > 30) {
      return {
        customValidation: 'Este campo não pode conter dois hífens seguidos',
      };
    }

    if (value.match(/[^a-z^A-Z^0-9^-]/g)) {
      return {
        customValidation: 'Este campo não pode conter caracteres especiais',
      };
    }

    return null;
  };
}
